import React from 'react';
import { Stack } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import { Dropdown } from 'src/UIKit';
import { TimePeriod } from '../../controllers/ReportsViewController';

interface ReportsFiltersProps {
  timePeriod: TimePeriod;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onTimePeriodChange: (period: TimePeriod) => void;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
}

const periodOptions = [
  { value: TimePeriod.LAST7DAYS, title: 'Last 7 Days' },
  { value: TimePeriod.LAST30DAYS, title: 'Last 30 Days' },
  { value: TimePeriod.LAST90DAYS, title: 'Last 90 Days' },
  { value: TimePeriod.CUSTOM, title: 'Custom Range' },
];

export const ReportsFilters: React.FC<ReportsFiltersProps> = ({
  timePeriod,
  startDate,
  endDate,
  onTimePeriodChange,
  onStartDateChange,
  onEndDateChange,
}) => (
  <Stack gap={2}>
    <Dropdown
      label="Time Period"
      value={timePeriod}
      options={periodOptions}
      onChange={(_, value) => onTimePeriodChange(value)}
      size="small"
      margin="none"
    />
    {timePeriod === TimePeriod.CUSTOM && (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack direction={{ xs: 'column', md: 'row' }} gap={2}>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={onStartDateChange}
            slotProps={{ textField: { size: 'small', fullWidth: true } }}
          />
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={onEndDateChange}
            slotProps={{ textField: { size: 'small', fullWidth: true } }}
          />
        </Stack>
      </LocalizationProvider>
    )}
  </Stack>
);
